module.exports = __webpack_public_path__ + "static/media/platziconf-logo.f246f5f1.svg";